import React, {Component} from 'react';

import TasSwitch from '../../../components/TasSwitch';

import ContractChart from './ContractChart';
import TerminateChart from './TerminateChart';
import ContractCards, {initData as ContractCardsInit } from './ContractCards';
import ContractYearPie from './ContractYearPie';
import BranchList from './BranchList';

import DerivativeChart from './DerivativeChart';
import BCGScatter from './BCGScatter';



import * as Constant from '@app/Constant.js';

import axios from '@app/lib/axios';

const calculateData = (_new, _renew, _terminate, last_new, last_renew, last_terminate) => {
    return {
        total : _new + _renew,
        total_growth : last_new + last_renew == 0 && last_new + last_renew > 0 ? 100 : last_new + last_renew <= 0 ? 0 : Math.ceil( ( ((_new+ _renew) - (last_new+ last_renew)) / (last_new + last_renew))*100 ),

        new_growth : last_new == 0 && _new > 0 ? 100 : last_new == 0 && _new <= 0 ? 0 : Math.ceil( ( (_new - last_new) / (last_new))*100 ),
        
        renew_growth : last_renew == 0 ? 0 : Math.ceil( ((_renew - last_renew) / (last_renew))*100 ),

        last_total : last_new+ last_renew,

        renew_rate : last_new + last_renew == 0 ? 0 : Math.ceil((_renew / (last_new + last_renew) ) * 100 ),
        terminate_rate : _new == 0 ? 0 : Math.ceil((_terminate / _new) * 100 ),


        new : _new,
        renew : _renew,
        terminate : _terminate,
        last_new : last_new,
        last_renew : last_renew,
        last_terminate : last_terminate
    }
}


class TasGlobal extends Component {

	constructor(props) {
		super(props);
        var year = new Date().getMonth() < 6 ? new Date().getFullYear() : new Date().getFullYear()+1;
		this.state = {
			year : year,
            isLoaded : false,
			chartData : [],
            thisYear : ContractCardsInit,
            tomonote : true,
            tomobooks : false,
            thisYearBranch : [],
            addr : "",
            data : null
		};
	}

	yearChange = (year) => {
		this.setState({
			year : year,
			chartData : [],
            thisYear : ContractCardsInit
		},() => this.drawDashboard(this.state.tomonote, this.state.tomobooks))
	}


    componentDidMount(){    
        this.getContractData(this.state.tomonote, this.state.tomobooks);
    }

    getContractData = (tomonote, tomobooks) => {
                
        axios({
          method: "get",
          url: Constant.API_DOMAIN + "/api/petit/branch/" + this.state.year
        })
          .then(result => {
            if(result.data.code === 200) {
                this.setState({data : result.data.data},
                    () => this.drawDashboard(tomonote, tomobooks));
                ;
            } 
            
          })
          .catch(error => {
            console.log(error);
            console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
        });
        
    }


    drawDashboard = (tomonote, tomobooks) => {

        var tomonoteBranchList = this.state.data.tomonote;
        var tomobooksBranchList = this.state.data.tomobooks;

        var yearList = [];
        var thisYearBranchList = [];
        var thisYear = null;

        this.state.data.targetYears.map(year =>{
            var _new = 0;
            var _renew = 0;
            var _terminate = 0;
            var last_new = 0;
            var last_renew = 0;
            var last_terminate = 0;
            var renew_terminate = 0;
            var branchNum = 0;
            var lastBranchNum = 0;

            var branchMap = {};

            if(tomonote) {
                tomonoteBranchList.map(branch => {
                    if(branch["validateBranch_" + year.year]){
                        _new += branch["n_" + year.year];
                        _renew += branch["rn_" + year.year];
                        _terminate += branch["t_" + year.year];
                        renew_terminate += branch["renew_t_" + year.year];
                        branchNum++;
                    }
                    
                    if(branch["validateBranch_" + (year.year-1)]){
                        last_new += branch["n_" + (year.year-1)];
                        last_renew += branch["rn_" + (year.year-1)];
                        last_terminate += branch["t_" + (year.year-1)];
                        lastBranchNum++;
                    }

                    if(this.state.year == year.year && branch["validateBranch_" + year.year]) {
                        branchMap[branch.id] = {
                            name : branch.name,
                            new : branch["n_" + year.year],
                            renew : branch["rn_" + year.year],
                            terminate : branch["t_" + year.year],
                            last_new : branch["n_" + (year.year-1)],
                            last_renew : branch["rn_" + (year.year-1)],
                            last_terminate : branch["t_" + (year.year-1)]
                        };
                    } 
                });
            }

        
            if(tomobooks) {
                branchNum = 0;
                lastBranchNum = 0;
                tomobooksBranchList.map(branch => {
                    if(branch["validateBranch_" + year.year]){
                        _new += branch["n_" + year.year];
                        _renew += branch["rn_" + year.year];
                        _terminate += branch["t_" + year.year];
                        branchNum++;
                    }
                    
                    if(branch["validateBranch_" + (year.year-1)]){
                        last_new += branch["n_" + (year.year-1)];
                        last_renew += branch["rn_" + (year.year-1)];
                        last_terminate += branch["t_" + (year.year-1)];
                        lastBranchNum++;
                    }


                    if(this.state.year == year.year && branch["validateBranch_" + year.year]) {
                        
                        var tomonoteData = branchMap[branch.id];

                        if(tomonoteData) {
                            branchMap[branch.id] = {
                                name : branch.name,
                                new : tomonoteData.new + branch["n_" + year.year],
                                renew : tomonoteData.renew + branch["rn_" + year.year],
                                terminate : tomonoteData.terminate + branch["t_" + year.year],
                                last_new : tomonoteData.last_new + branch["n_" + (year.year-1)],
                                last_renew : tomonoteData.last_renew + branch["rn_" + (year.year-1)],
                                last_terminate : tomonoteData.last_terminate + branch["t_" + (year.year-1)]
                            }
                        } else {
                            branchMap[branch.id] = {
                                name : branch.name,
                                new : branch["n_" + year.year],
                                renew : branch["rn_" + year.year],
                                terminate : branch["t_" + year.year],
                                last_new : branch["n_" + (year.year-1)],
                                last_renew : branch["rn_" + (year.year-1)],
                                last_terminate : branch["t_" + (year.year-1)]
                            };
                        }
                        
                    } 
                });
            }


            var branchKeyList = Object.keys(branchMap);

            branchKeyList.forEach(key=> {
                var branchData = branchMap[key];
                var BCG = "A";
                var bcgScore = {x : 0, y : 0};
                switch (key % 4) {
                    case 0: 
                        BCG = 'A';
                        bcgScore = {
                            x : Math.random()* (10 - 0) + 0,
                            y : Math.random()* (10 - 0) + 0
                        };
                        break; 
                    case 1: BCG = 'B';
                        bcgScore = {
                            x : Math.random()* (10 - 0) + 0,
                            y : -(Math.random()* (10 - 0) + 0)
                        };
                        break;
                    case 2: BCG = 'C';
                        bcgScore = {
                            x : -(Math.random()* (10 - 0) + 0),
                            y : Math.random()* (10 - 0) + 0
                        };
                        break;
                    case 3: BCG = 'D';
                        bcgScore = {
                            x : -(Math.random()* (10 - 0) + 0),
                            y : -(Math.random()* (10 - 0) + 0)
                        };
                        break;
                }

                thisYearBranchList.push({
                    id : key,
                    name : branchData.name,
                    bcg : BCG,
                    bcgScore : bcgScore,
                    data : calculateData(branchData.new, branchData.renew, branchData.terminate, branchData.last_new, branchData.last_renew, branchData.last_terminate)
                });
            });


            // 임시 랜덤 
            var books = Math.ceil(Math.random() * (4000 - 300) + 300);
            var playkit = Math.ceil(Math.random() * (4000 - 300) + 300);
            var kidsfarm = Math.ceil(Math.random() * (4000 - 300) + 300);
            var experience = Math.ceil(Math.random() * (4000 - 300) + 300);

            var yearTotalData = calculateData(_new, _renew, _terminate, last_new, last_renew, 0);
            yearList.push({
                name : year.year,
                "신규": _new, 
                "재계약": _renew, 
                "재계약률": yearTotalData.renew_rate, 

                "신규해지" : _terminate,
                "재계약해지" : renew_terminate,
                "해지율" : Math.ceil( ((_terminate + renew_terminate) / yearTotalData.total) * 100),
                "토모동화" : books,
                "플레이키트" : playkit,
                "키즈팜" : kidsfarm,
                "체험관" : experience
            });

            if(this.state.year == year.year) {
                thisYear = yearTotalData;
                thisYear.branch = branchNum;
                thisYear.lastBranch = lastBranchNum;
                thisYear.terminate = _terminate;
                thisYear.renew_terminate = renew_terminate;

                thisYear.books = books;
                thisYear.playkit = playkit;
                thisYear.kidsfarm = kidsfarm;
                thisYear.experience = experience;


            }
        });

        
        thisYearBranchList.forEach(branch => {
            branch.data.rate = thisYear.total == 0 ? 0 : Math.ceil((branch.data.total / thisYear.total) *100);

            branch.data.derivative = Math.ceil(Math.random() * (4000 - 300) + 300);
        });

        

        this.setState({
            chartData : yearList,
            thisYearBranch : thisYearBranchList,
            thisYear : thisYear,
            tomonote : tomonote, 
            tomobooks : tomobooks
        });
    }


    tomonoteHandleChange = (checked) => {
        if(!checked && !this.state.tomobooks) {
            alert("토모노트 혹은 토모동화 둘 중 하나라도 선택해야 합니다.");
        } else {
            this.drawDashboard(checked, this.state.tomobooks);    
        }
    }


    tomobooksHandleChange = (checked) => {
        if(!checked && !this.state.tomonote) {
            alert("토모노트 혹은 토모동화 둘 중 하나라도 선택해야 합니다.");
        } else {
            this.drawDashboard(this.state.tomonote, checked);    
        }
    }


	render() {
		
		return (

			<div className="dashboard-wrapper">
                <div className="dashboard-ecommerce">
                    <div className="container-fluid dashboard-content ">

                       	<div className="row">
                       		<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <BranchList year={this.state.year} branchList={this.state.thisYearBranch} height={500} />
                            </div>
                       	</div>
                    </div>
                </div>
            </div>

		)
	}


}


export default TasGlobal;